import Axios from "axios";
import { loadModules } from "esri-loader";
import React from "react";
import { TYPE } from "../../types";
import { debounce } from "../../utils";
import { configContext } from "../config-provider";
import { SearchWithOption } from "../input";
import { featureLayer, typeToNumber, view } from "./";

interface ArcGisSearchProps {
  type: TYPE;
  value: string;
  onChange: (value: string) => void;
  onClick: (value: string) => void;
}

let highlighted: any = null;
export const ArcGisSearch: React.FC<ArcGisSearchProps> = (props) => {
  const { value, onChange, onClick, type } = props;
  const { arcgisURL } = React.useContext(configContext);
  const [state, setState] = React.useState({
    options: [],
  });

  const arcgisRequest = async (value: string) => {
    const [QueryTask, Query] = await loadModules([
      "esri/tasks/QueryTask",
      "esri/tasks/support/Query",
    ]);

    const mapping = typeToNumber(type);

    const qTask = new QueryTask({
      url: `${arcgisURL}${mapping.type}`,
    });

    const params = new Query({
      returnGeometry: true,
      outFields: ["*"],
      outSpatialReference: {
        wkid: 4326,
      },
    });

    // params.where = `LAMP_NO LIKE '%${value}%'`;
    params.where = `${mapping.key} = '${value}'`;

    qTask.execute(params).then((res: any) => {
      if (res.features.length === 0) return;

      const results = res.features.map((feature: any) => {
        feature.popupTemplate = {
          title: `{${mapping.key}}`,
        };
        return feature;
      });

      if (view) {
        if (results[0].geometry.x) {
          view.center = [results[0].geometry.x, results[0].geometry.y];
        } else {
          view.center = [
            results[0].geometry.extent.center.x,
            results[0].geometry.extent.center.y,
          ];
        }

        view.zoom = 23;
        view.whenLayerView(featureLayer).then((layerView: any) => {
          if (highlighted) highlighted.remove();

          highlighted = layerView.highlight(results[0].attributes["OBJECTID"]);
        });
      }
    });
  };

  const handleOnChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = evt.target;
    onChange(value);
    debounceOnChange(value);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      handleOnItemClick(value);
    }
  };

  const handleOnItemClick = (no: any) => {
    onClick(no);
    arcgisRequest(no);
  };

  const debounceOnChange = React.useCallback(
    debounce((value: string) => {
      Axios.get(`/${type}/search`, { params: { no: value } }).then((res) => {
        setState({
          ...state,
          options: res.data.map((row: any) => {
            return {
              no: row.no,
            };
          }),
        });
      });
    }, 500),
    []
  );

  return (
    <SearchWithOption
      id="arcgis-search"
      className="arcgis-search"
      handleOnChange={handleOnChange}
      handleKeyDown={handleKeyDown}
      handleOnItemClick={handleOnItemClick}
      value={value}
      options={state.options}
    />
  );
};
